import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
  useCallback,
} from 'react'

type HelpDrawerContextType = {
  isOpen: boolean
  url: string | null
  title: string | null
  openHelpDrawer: (url: string, title?: string) => void
  closeHelpDrawer: () => void
}

const HelpDrawerContext = createContext<HelpDrawerContextType | undefined>(
  undefined,
)

export const HelpDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [url, setUrl] = useState<string | null>(null)
  const [title, setTitle] = useState<string | null>(null)

  const openHelpDrawer = useCallback((url: string, title?: string) => {
    setUrl(url)
    setTitle(title ?? null)
    setIsOpen(true)
  }, [])

  const closeHelpDrawer = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <HelpDrawerContext.Provider
      value={{
        isOpen,
        url,
        title,
        openHelpDrawer,
        closeHelpDrawer,
      }}
    >
      {children}
    </HelpDrawerContext.Provider>
  )
}

export const useHelpDrawer = (): HelpDrawerContextType => {
  const context = useContext(HelpDrawerContext)
  if (context === undefined) {
    throw new Error('useHelpDrawer must be used within a HelpDrawerProvider')
  }
  return context
}
